<div class="provider-details-container" *ngIf="provider">
  <mat-card appearance="outlined">
    <mat-card-content class="card-content">
      <mat-tab-group class="details-tab-group">
        <mat-tab label="Details">
          <div class="search-disciplines">
            <button
              mat-raised-button
              (click)="navigateToDisciplinesPage(provider)"
              matTooltip="Search for disciplines"
              class="search-disciplines-button"
            >
              <mat-icon>search</mat-icon>
              Search for disciplines
            </button>
          </div>

          <div class="inline mt-10">
            <h4 *ngIf="provider?.status">
              <strong>Status: {{ provider?.status }} </strong>
            </h4>
          </div>

          <div class="inline" *ngIf="provider?.type">
            <mat-icon class="mat-icon-small">health_and_safety</mat-icon>
            <p><strong>Type:</strong> {{ provider?.type }}</p>
          </div>
          <div class="inline" *ngIf="getAddress(provider)">
            <mat-icon class="mat-icon-small">house</mat-icon>
            <p>
              <strong>Address:</strong>
              {{ getAddress(provider) }}
            </p>
          </div>

          <div class="inline" *ngIf="provider?.email">
            <mat-icon class="mat-icon-small">email</mat-icon>
            <p><strong>Email:</strong></p>
            <p>{{ provider.email }}</p>
          </div>

          <div class="inline" *ngIf="provider?.phone">
            <mat-icon class="mat-icon-small">phone</mat-icon>
            <p><strong>Phone:</strong></p>
            <p>{{ provider.phone }}</p>
          </div>

          <div class="inline" *ngIf="provider?.fax">
            <mat-icon class="mat-icon-small">fax</mat-icon>
            <p><strong>Fax:</strong></p>
            <p>{{ provider.fax }}</p>
          </div>

          <div class="inline" *ngIf="provider?.accreditationNumber">
            <mat-icon class="mat-icon-small">numbers</mat-icon>
            <p>
              <strong>Accreditor:</strong>
              {{ provider.accreditationNumber }}
            </p>
          </div>

          <div class="inline" *ngIf="provider?.dateIssued">
            <mat-icon class="mat-icon-small">date_range</mat-icon>
            <p>
              <strong>Issued: </strong
              >{{ provider.dateIssued | date : dateFormat }}
            </p>
            <p *ngIf="provider.dateClosed">
              -- <strong>Closed: </strong>
              {{ provider.dateClosed | date : dateFormat }}
            </p>
          </div>

          <p *ngIf="provider?.licenceEffectiveDate">
            <strong>Licence effective date:</strong>
            {{ provider.licenceEffectiveDate | date : dateFormat }}
          </p>
          <p *ngIf="provider?.licenceExpiryDate">
            <strong>Licence expiry date:</strong>
            {{ provider.licenceExpiryDate | date : dateFormat }}
          </p>

          <div class="inline mt-10" *ngIf="provider?.website?.regulatoryBody">
            <p>
              <strong>Regulatory Body: </strong
              >{{ provider.website.regulatoryBody }}
            </p>
            <a
              *ngIf="
                formatUrl(
                  provider?.website?.regulatoryBodyWebsite
                ) as regulatoryBodyWebsite
              "
              [href]="regulatoryBodyWebsite"
              [matTooltip]="regulatoryBodyWebsite"
              target="_blank"
              class="link-with-icon"
              rel="noopener"
              aria-label="Opens in a new tab"
            >
              <mat-icon class="mat-icon-small">open_in_new</mat-icon>
            </a>
          </div>

          <div class="mt-10" *ngIf="provider?.owner">
            <p class="title-section"><strong>Organization</strong></p>
            <div class="inline">
              <p *ngIf="provider?.owner?.name">
                Name: {{ provider.owner?.name }}
              </p>
              <p *ngIf="!provider?.owner?.name">Link:</p>
              <a
                *ngIf="formatUrl(provider?.url) as providerUrl"
                [href]="providerUrl"
                [matTooltip]="providerUrl"
                target="_blank"
                class="link-with-icon"
                rel="noopener"
                aria-label="Opens in a new tab"
              >
                <mat-icon class="mat-icon-small">open_in_new</mat-icon>
              </a>
            </div>

            <p *ngIf="provider?.owner?.type">
              Type: {{ provider?.owner?.type }}
            </p>
            <p *ngIf="provider?.providerWebsite">
              Website: {{ provider?.providerWebsite }}
            </p>

            <div *ngIf="provider?.owner?.directors?.length > 0" class="mt-10">
              <p class="title-section"><strong>Director(s):</strong></p>
              <ul class="horizontal-professional-list">
                <li
                  *ngFor="let staff of provider?.owner?.directors"
                  class="staff-card"
                >
                  <mat-icon
                    class="concern-warning"
                    *ngIf="staff?.professional?.events?.length > 0"
                    >warning</mat-icon
                  >
                  <button
                    class="search-entity-button"
                    mat-raised-button
                    (click)="navigateToProfessionalPage(staff?.professional)"
                    matTooltip="Search for professional"
                  >
                    {{ staff?.name ?? staff?.professional?.name }}
                  </button>

                  <div class="mt-10">
                    <p *ngIf="staff?.profession || staff?.professional?.profession">
                      Profession: {{ staff?.profession ?? staff?.professional?.profession }}
                    </p>
                    <p *ngIf="staff?.position">
                      <Strong>Position:</Strong>
                      {{ staff?.position }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="provider.staff.length > 0" class="mt-10">
            <p class="title-section"><strong>Staff:</strong></p>
            <ul class="horizontal-professional-list">
              <li *ngFor="let staff of provider?.staff" class="staff-card">
                <mat-icon
                  class="concern-warning"
                  *ngIf="staff?.professional?.events?.length > 0"
                  >warning</mat-icon
                >
                <button
                  class="search-entity-button"
                  mat-raised-button
                  matSuffix
                  (click)="navigateToProfessionalPage(staff?.professional)"
                  matTooltip="Search for professional"
                >
                  {{ staff?.name ?? staff?.professional?.name }}
                </button>

                <div class="mt-10">
                  <p *ngIf="staff?.position">
                    <strong>Position:</strong> {{ staff?.position }}
                  </p>
                  <p *ngIf="staff?.profession || staff?.professional?.profession">
                    <strong>Profession:</strong>
                    {{ staff?.profession ?? staff?.professional?.profession }}
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div class="last-updated">
            <p>
              Last updated:
              {{ provider?.lastUpdatedDate | date : dateFormat }}
            </p>
          </div>
        </mat-tab>

        <mat-tab *ngIf="provider.hasConcerns">
          <ng-template mat-tab-label>
            <mat-icon class="concern-warning">warning</mat-icon>
            {{ concernTypes }}
          </ng-template>
          <ng-container *ngIf="provider?.events?.[0]?.documents?.length > 0">
            <div *ngFor="let document of provider.events[0].documents" class="document-wrapper">

              <app-safe-html-viewer
              [matTooltip]="document?.url ? 'Download file: ' + document?.url : ''"
              [rawHtml]="getDocumentHtml(document)"
            ></app-safe-html-viewer>
              
            </div>
          </ng-container>

          <div class="last-updated" *ngIf="provider?.lastUpdatedDate">
            <p>
              Last updated:
              {{ provider?.lastUpdatedDate | date : dateFormat }}
            </p>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
